import { useEffect, useRef } from 'react';
import type { MeetingDetail } from '@shared/contract';
import { formatDuration } from '../lib/format';

export function Transcript({ detail, highlight, live }: { detail: MeetingDetail; highlight: string | null; live: boolean }) {
  const box = useRef<HTMLDivElement>(null);
  const stick = useRef(true);

  useEffect(() => {
    const el = box.current;
    if (el && live && stick.current) el.scrollTop = el.scrollHeight;
  }, [detail.transcript.length, live]);

  useEffect(() => {
    if (!highlight) return;
    document.getElementById(`t-${highlight}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [highlight]);

  return (
    <div
      className="transcript"
      ref={box}
      onScroll={(e) => {
        const el = e.currentTarget;
        stick.current = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
      }}
    >
      {detail.transcript.length === 0 ? (
        <p className="muted">
          {detail.status === 'created'
            ? 'Transkriptionen visas här när mötet har startat.'
            : 'Ingen transkriberad text ännu. Text visas normalt inom några sekunder efter att något sagts.'}
        </p>
      ) : (
        detail.transcript.map((t) => (
          <p
            key={t.id}
            id={`t-${t.id}`}
            className={`tline${t.is_final ? '' : ' preliminary'}${highlight === t.id ? ' highlight' : ''}`}
          >
            <span className="ts">{formatDuration(t.start_ms)}</span>
            <span>{t.text}</span>
          </p>
        ))
      )}
    </div>
  );
}
